module.exports = __webpack_public_path__ + "images/cover3.13adb2ca.jpeg";